export let getSiteResDomain = function() {
  let domain = "";
  let host = window.location.host;
  const hostArray = host.split(".");
  if (hostArray[0] !== "localhost") {
    hostArray[0] = "image";
    domain = hostArray.join(".");
  }
  return domain;
};

export let goTop = function() {
  const _btn: any = document.getElementById("goTop");
  let _con: any;
  if (document.documentElement && document.documentElement.scrollTop) {
    _con = document.documentElement;
  } else if (document.body) {
    _con = document.body;
  }
  if (_con.offsetWidth > 1024 && _con.scrollTop != 0) {
    _btn.style.display = "block";
    _btn.style.right = 25 + "px";
    _btn.style.bottom = 45 + "px";
  } else {
    _btn.style.display = "none";
  }
  _btn.onmouseover = function() {
    _btn.style.opacity = 1;
  };
  _btn.onmouseout = function() {
    _btn.style.opacity = 0.5;
  };
  _btn.onclick = function() {
    window.onscroll = set;
    _con.scrollTop = 0;
  };
  function set() {
    _btn.style.display = _con.scrollTop ? "block" : "none";
  }
};
